export const SUPPORTED_LOCALES = [
    { code: 'ko', flag: '🇰🇷', label: '한국어' },
    { code: 'en', flag: '🇺🇸', label: 'English' },
    { code: 'vi', flag: '🇻🇳', label: 'Tiếng Việt' },
    { code: 'zh', flag: '🇨🇳', label: '中文' },
] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number]['code'];
